var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSw1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3192 10.6685C36.3025 11.3585 35.7309 11.9052 35.0409 11.8902C34.3509 11.8735 33.8042 11.3018 33.8192 10.6118L33.8875 7.60184L30.8792 7.5335C30.1892 7.51684 29.6425 6.94517 29.6575 6.25517C29.6742 5.56517 30.2459 5.0185 30.9359 5.0335L35.1959 5.13184C35.8859 5.14684 36.4325 5.7185 36.4159 6.4085L36.3192 10.6685Z",
    fill: "#35AB33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71134 15.5767V35.8117C9.71134 36.975 8.76967 37.9167 7.60634 37.9167H4.18801C3.02467 37.9167 2.08301 36.975 2.08301 35.8117V15.5767C2.08301 14.415 3.02467 13.4717 4.18801 13.4717H7.60634C8.76967 13.4717 9.71134 14.415 9.71134 15.5767Z",
    fill: "#35AB33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5151 25.8335V35.8118C28.5151 36.3702 28.2934 36.9052 27.8984 37.3002C27.5034 37.6952 26.9684 37.9168 26.4101 37.9168H22.9917C22.4334 37.9168 21.8984 37.6952 21.5034 37.3002C21.1084 36.9052 20.8867 36.3702 20.8867 35.8118V25.8335C20.8867 25.2752 21.1084 24.7402 21.5034 24.3452C21.8984 23.9502 22.4334 23.7285 22.9917 23.7285H26.4101C26.9684 23.7285 27.5034 23.9502 27.8984 24.3452C28.2934 24.7402 28.5151 25.2752 28.5151 25.8335Z",
    fill: "#35AB33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1127 20.7051V35.8118C19.1127 36.9751 18.171 37.9168 17.0077 37.9168H13.5894C12.426 37.9168 11.4844 36.9751 11.4844 35.8118V20.7051C11.4844 20.1468 11.706 19.6118 12.101 19.2168C12.496 18.8218 13.031 18.6001 13.5894 18.6001H17.0077C18.171 18.6001 19.1127 19.5434 19.1127 20.7051Z",
    fill: "#35AB33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9164 20.7051V35.8118C37.9164 36.9751 36.9748 37.9168 35.8114 37.9168H32.3931C31.2298 37.9168 30.2881 36.9751 30.2881 35.8118V20.7051C30.2881 20.1468 30.5098 19.6118 30.9048 19.2168C31.2998 18.8218 31.8348 18.6001 32.3931 18.6001H35.8114C36.9748 18.6001 37.9164 19.5434 37.9164 20.7051Z",
    fill: "#35AB33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.08275 4.3335C3.52942 3.92016 3.41775 3.13516 3.83275 2.5835C4.24608 2.03183 5.02942 1.92016 5.58275 2.3335L15.5044 9.77516H20.2161C20.6011 9.77516 20.9628 9.95183 21.1994 10.2535L25.0111 15.1052L33.8444 5.88683C34.3211 5.3885 35.1128 5.37183 35.6111 5.85016C36.1094 6.32683 36.1261 7.1185 35.6494 7.61683L25.8194 17.8735C25.5694 18.1352 25.2178 18.2752 24.8561 18.2568C24.4944 18.2402 24.1578 18.0652 23.9344 17.7802L19.6094 12.2752H15.0878C14.8178 12.2752 14.5544 12.1885 14.3378 12.0252L4.08275 4.3335Z",
    fill: "#35AB33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSw1);
export default __webpack_public_path__ + "static/media/sw1.1f54d4557c264f65720031d79b053eb1.svg";
export { ForwardRef as ReactComponent };